import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.classNameBase.rootElement,
      `${_ctx.classNameBase.rootElement}${_ctx.classNameDirection[_ctx.isYouSent]}`
    ]),
    style: _normalizeStyle(_ctx.isYouSent ? { backgroundColor: _ctx.colorCode } : {})
  }, [
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 6))
}